import Vue from 'vue'
import '@bfe/mtd-theme-472/index.css'
import '@/assets/styles/mtd-diy.scss'
import MTD from '@ss/mtd-vue'

Vue.use(MTD)
